export const translations = {
  sq: {
    // Nav
    nav_home: "Kryefaqe", nav_about: "Rreth Nesh", nav_events: "Evente", nav_trainers: "Trajnere",
    nav_gallery: "Galeria", nav_blog: "Blog", nav_contact: "Kontakt",
    // Hero
    hero_welcome: "Miresevini ne", hero_brand: "Albanian Aligners Academy",
    hero_title: "Akademia Shqiptare e Alignerave per dentistet, nga dentistet.",
    hero_desc: "Albanian Aligners Academy eshte simbol i ekselences ne terapi me aligner, duke ofruar edukim te vazhdueshem, mentorim nga ekspertet dhe nje rruge te certifikuar akreditimi per profesionistet qe duan te dallohen ne ortodonci moderne.",
    hero_read_more: "Lexo me shume", hero_view_events: "Shiko eventet",
    // Stats
    stat_participants: "Pjesemarres", stat_certifications: "Certifikime", stat_events: "Evente", stat_trainers: "Trajnere Ekspert",
    // About preview
    about_who: "Kush jemi ne", about_title: "Lider ne Edukimin Profesional per Aligneret ne Shqiperi dhe me gjere",
    about_p1: "Ndersa shkolla e stomatologjise ofron nje baze per trajtimin e dhembeve individuale, shume dentiste kuptojne shpejt qe ajo nuk i pergatit plotesisht per te adresuar shkaktaret themelore te problemeve te pacienteve. Ata qe ndjekin edukimin e vazhdueshem ne Albanian Aligners Academy e pershkruajne pervojen si \"hapje sysh\" dhe thellesisht transformuese, duke sjelle ato momente vendimtare qe ndryshojne rrenjesisht qasjen ndaj kujdesit dentar.",
    about_p2: "Albanian Aligners Academy ofron trajnime te specializuara, workshope praktike dhe edukim te vazhdueshem per dentistet qe duan te thellojne njohurite ne fushen e aligner-eve dhe ortodoncise moderne.",
    // Events section
    events_label: "Eventet", events_upcoming: "Eventet e Ardhshme", events_past: "Eventet e Kaluara", events_view_all: "Shiko te gjitha",
    events_no_upcoming: "Nuk ka evente te ardhshme per momentin.", events_no_past: "Nuk ka evente te kaluara.",
    event_upcoming_badge: "E ardhshme", event_past_badge: "E kaluar", event_details: "Detaje",
    event_next: "Eventi i Rradhes", event_days: "Dite", event_hours: "Ore", event_min: "Min", event_sec: "Sek",
    // Events page
    events_hero_title: "Evente",
    events_hero_desc: "Kalendari yne i eventeve live eshte i mbushur plot me ngjarje unike dhe edukim te gjalle profesional, ku dijet takohen me pasionin!",
    events_hero_p2: "Nga intervista me eksperte nderkombetare, diskutime klinike interaktive, formate ne stilin TED, talk show dentare, deri te konferenca online dhe trajnime te drejtperdrejta - cdo event eshte krijuar per te frymezuar, informuar dhe permiresuar praktiken tende klinike.",
    events_hero_check: "Shiko live. Meso ndryshe. Zbulo me shume.",
    events_hero_italic: "Bashkohu me komunitetin e profesionisteve qe kerkojne me shume se thjesht nje trajnim.",
    events_scroll_btn: "Shiko Eventet",
    events_masterclass_label: "Masterclass 2026", events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_sub: "From Fundamentals to Full-Arch Excellence",
    events_masterclass_modules: "6 Module", events_masterclass_dates: "Qershor - Tetor 2026",
    events_masterclass_view: "Shiko Modulet",
    home_masterclass_desc: "Programi me i plote i implantologjise ne rajon. 6 module intensive me 9+ eksperte nderkombetare, nga bazat deri ne rehabilitimin full-arch.",
    events_join_title: "Bashkohu ne Panele me Eksperte dhe behu pjese e Eventeve Unike",
    events_join_p1: "Albanian Aligners Academy po pasuron vazhdimishtri kalendarin e saj me evente te reja, permbajtje me vlere dhe mundesi te reja zhvillimi profesional per ortodoncet, dentistet dhe te gjithe profesionistet e fushes dentare.",
    events_join_p2: "Nga workshop-e praktike te fokusuara ne temat me te avancuara te ortodoncise dixhitale dhe sistemet aligner, deri te konferencat nderkombetare virtuale dhe fizike me pjesemarrjen e disa prej emrave me te njohur ne bote, akademia ofron nje platforme te hapur per mesim, shkembim pervojash dhe ndertim komuniteti.",
    events_join_p3: "Ne besojme se bashkepunimi profesional, mjetesimi dhe qasja ne dije te perdorueshme jane nder faktoret me te rendesishem per zhvillimin e qendrueshëm te cdo profesionisti ne stomatologji dhe ortodonci. Kjo eshte arsyeja pse cdo event qe organizojme fokusohet jo vetem ne aspektin teorik dhe teknologjik, por edhe ne ndertimin e nje kulture bashkepunimi dhe perkushtimi ndaj ekselences klinike.",
    events_meet_trainers: "NJIHU ME TRAJNERET TANE",
    events_cta_title: "Bashkohu ne Panele me Eksperte",
    events_cta_desc: "Nga workshop-e praktike deri te konferencat nderkombetare - cdo event eshte dizenjuar per zhvillimin tend profesional.",
    // Event detail
    event_breadcrumb_home: "Kryefaqe", event_breadcrumb_events: "Evente", event_breadcrumb_detail: "Detaje",
    event_description: "Pershkrimi i Eventit", event_what_learn: "Cfare do te mesohet",
    event_who_for: "Kujt i dedikohet", event_agenda: "Axhenda / Programi",
    event_register_title: "Regjistrohu per kete Event", event_finished: "Ky event ka perfunduar.",
    event_view_upcoming: "Shiko eventet e ardhshme",
    // Registration form
    reg_first_name: "Emri", reg_last_name: "Mbiemri", reg_email: "Email", reg_phone: "Telefon",
    reg_participants: "Nr. Pjesemarresve", reg_message: "Mesazh (opsional)", reg_submit: "Regjistrohu Tani",
    reg_submitting: "Duke regjistruar...", reg_required: "Ju lutem plotesoni fushat e detyrueshme.",
    reg_success_title: "Regjistrimi u krye!", reg_success_msg: "Faleminderit per regjistrimin. Do t'ju kontaktojme se shpejti.",
    // Trainers
    trainers_label: "Ekspertet tane", trainers_title: "Trajnere Nderkombetare",
    trainers_view_all: "Njihu me trajneret tane", trainers_loading: "Duke ngarkuar...",
    // CTA
    cta_title: "Bashkohu ne Panele me Eksperte dhe behu pjese e Eventeve Unike",
    cta_desc: "Nga workshop-e praktike te foksuara ne temat me te avancuara te ortodoncise dixhitale dhe sistemit aligner, deri te konferencat nderkombetare virtuale dhe fizike.",
    cta_contact: "Na Kontaktoni",
    // FAQ
    faq_label: "Pyetje", faq_title: "Pyetjet me te shpeshta",
    // Contact
    contact_title: "Kontakt", contact_subtitle: "Na dergoni pyetjet tuaja ose kerkesat per bashkepunim. Jemi ketu per t'ju ndihmuar!",
    contact_info_title: "Informacion Kontakti", contact_form_title: "Forme Kontakti",
    contact_address_label: "Adresa", contact_phone_label: "Nr. Cel", contact_email_label: "Email",
    contact_hours_label: "Orari", contact_hours_value: "e Hene - e Shtune | 08:00 - 17:00",
    contact_follow: "Na Ndiqni", contact_follow_desc: "Na ndiqni ne rrjete sociale per lajme dhe eventet e reja.",
    contact_name: "Emer", contact_surname: "Mbiemer", contact_subject: "Subjekti", contact_message: "Mesazhi juaj",
    contact_terms: "Duke vazhduar, une pranoj", contact_terms_link: "Kushtet e Perdorimit",
    contact_privacy_link: "Politika e Privatesise", contact_and: "dhe",
    contact_sending: "Duke derguar...", contact_send: "Dergo",
    contact_success_title: "Faleminderit!", contact_success_msg: "Mesazhi juaj u dergua me sukses. Do t'ju kontaktojme se shpejti.",
    contact_send_another: "Dergo nje mesazh tjeter",
    contact_error: "Ka ndodhur nje gabim. Ju lutem provoni perseri.",
    contact_required: "Ju lutem plotesoni te gjitha fushat e detyrueshme.",
    // Footer
    footer_menu: "Menu", footer_upcoming: "Eventet e Ardhshme", footer_contact: "Kontakt",
    footer_no_events: "Nuk ka evente te ardhshme.", footer_brand: "Akademia Shqiptare e Alignerave per dentistet, nga dentistet.",
    footer_rights: "Te Drejtat e Rezervuara", footer_powered: "Powered by",
    // Gallery
    gallery_title: "Galeria", gallery_subtitle: "Momente nga eventet dhe trajnimet tona.",
    gallery_photos: "foto", gallery_empty: "Nuk ka albume ne galeri.",
    // Blog
    blog_title: "Blog", blog_subtitle: "Artikuj dhe lajme nga bota e dentistrise dhe alignerave.",
    blog_read_more: "Lexo me shume", blog_empty: "Nuk ka artikuj ne blog.",
    blog_back: "Kthehu ne Blog",
    // About page
    about_page_title: "Rreth Nesh",
    about_page_subtitle: "Njihuni me Albanian Aligners Academy - Akademia Shqiptare per Aligneret.",
    // Common
    // Auto-added multilingual keys
    hero_next_module_prefix: "Moduli",
    hero_countdown_days: "Dite",
    hero_countdown_hours: "Ore",
    hero_countdown_min: "Min",
    hero_countdown_sec: "Sek",
    hero_masterclass_finished: "Masterclass i perfunduar",
    hero_masterclass_6modules: "6 Module",
    hero_view_more: "Shiko me shume",
    hero_starts_in: "FILLON PER:",
    home_upcoming_label: "Te Ardhshme",
    home_upcoming_title: "Eventet e ardhshme",
    home_upcoming_view_all: "Shiko te gjitha",
    home_upcoming_click_to_select: "Klikoni per te zgjedhur",
    tier_choose_package: "Zgjidh Paketen",
    tier_now_badge: "Tani",
    tier_expired_badge: "Skaduar",
    tier_click_to_select: "Klikoni per te zgjedhur",
    tier_package: "Paketa",
    event_topics_label: "Tematikat",
    event_topics_title: "Programi i Plote i Dites",
    event_speaker_label: "Folesi",
    event_date_label: "Data",
    event_location_label: "Vendndodhja",
    event_schedule_label: "Orari",
    event_price_label: "Cmimi",
    register_now: "Regjistrohu",
    register_now_full: "Regjistrohu Tani",
    buy_now: "Bli Tani",
    register_processing: "Duke procesuar...",
    register_confirm: "Konfirmo Regjistrimin",
    register_continue_payment: "Vazhdo me Pagesen",
    popup_event_price: "Cmimi i eventit",
    popup_saved: "U ruajt me sukses",
    breadcrumb_home: "Kryefaqe",
    breadcrumb_events: "Evente",
    breadcrumb_upcoming: "Evente te Ardhshme",
    breadcrumb_trainers: "Trajnere",
    breadcrumb_privacy: "Politika e Privatesise",
    trainers_hero_desc: "Eksperte nderkombetare dhe vendas qe sjellin pervoje te jashtezakonshme ne cdo trajnim.",
    close: "Mbyll",
    cancel: "Anulo",
    save: "Ruaj",
    free: "Falas"
  },
  en: {
    nav_home: "Home", nav_about: "About Us", nav_events: "Events", nav_trainers: "Trainers",
    nav_gallery: "Gallery", nav_blog: "Blog", nav_contact: "Contact",
    hero_welcome: "Welcome to", hero_brand: "Albanian Aligners Academy",
    hero_title: "The Albanian Aligner Academy for dentists, by dentists.",
    hero_desc: "Albanian Aligners Academy is a symbol of excellence in aligner therapy, offering continuing education, expert mentoring and a certified accreditation pathway for professionals who want to excel in modern orthodontics.",
    hero_read_more: "Read more", hero_view_events: "View events",
    stat_participants: "Participants", stat_certifications: "Certifications", stat_events: "Events", stat_trainers: "Expert Trainers",
    about_who: "Who we are", about_title: "Leaders in Professional Education for Aligners in Albania and beyond",
    about_p1: "While dental school provides a foundation for treating individual teeth, many dentists quickly realize it doesn't fully prepare them to address the root causes of patient problems. Those who pursue continuing education at Albanian Aligners Academy describe the experience as \"eye-opening\" and deeply transformative, bringing those pivotal moments that fundamentally change their approach to dental care.",
    about_p2: "Albanian Aligners Academy offers specialized training, hands-on workshops and continuing education for dentists who want to deepen their knowledge in the field of aligners and modern orthodontics.",
    events_label: "Events", events_upcoming: "Upcoming Events", events_past: "Past Events", events_view_all: "View all",
    events_no_upcoming: "No upcoming events at this time.", events_no_past: "No past events.",
    event_upcoming_badge: "Upcoming", event_past_badge: "Past", event_details: "Details",
    event_next: "Next Event", event_days: "Days", event_hours: "Hrs", event_min: "Min", event_sec: "Sec",
    events_hero_title: "Events",
    events_hero_desc: "Our live events calendar is packed with unique occasions and vibrant professional education where knowledge meets passion!",
    events_hero_p2: "From interviews with international experts, interactive clinical discussions, TED-style formats, dental talk shows, to online conferences and live trainings - every event is designed to inspire, inform and improve your clinical practice.",
    events_hero_check: "Watch live. Learn differently. Discover more.",
    events_hero_italic: "Join the community of professionals who seek more than just training.",
    events_scroll_btn: "View Events",
    events_masterclass_label: "Masterclass 2026", events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_sub: "From Fundamentals to Full-Arch Excellence",
    events_masterclass_modules: "6 Modules", events_masterclass_dates: "June - October 2026",
    events_masterclass_view: "View Modules",
    home_masterclass_desc: "The most complete implantology programme in the region. 6 intensive modules with 9+ international experts, from fundamentals to full-arch rehabilitation.",
    events_join_title: "Join Expert Panels and be part of Unique Events",
    events_join_p1: "Albanian Aligners Academy continuously enriches its calendar with new events, valuable content and new professional development opportunities for orthodontists, dentists and all dental field professionals.",
    events_join_p2: "From hands-on workshops focused on the most advanced topics of digital orthodontics and aligner systems, to international virtual and physical conferences featuring some of the world's most renowned names, the academy offers an open platform for learning, experience sharing and community building.",
    events_join_p3: "We believe that professional collaboration, craftsmanship and access to usable knowledge are among the most important factors for the sustainable development of every professional in dentistry and orthodontics.",
    events_meet_trainers: "MEET OUR TRAINERS",
    events_cta_title: "Join Expert Panels",
    events_cta_desc: "From hands-on workshops to international conferences - every event is designed for your professional development.",
    event_breadcrumb_home: "Home", event_breadcrumb_events: "Events", event_breadcrumb_detail: "Details",
    event_description: "Event Description", event_what_learn: "What you will learn",
    event_who_for: "Who is it for", event_agenda: "Agenda / Program",
    event_register_title: "Register for this Event", event_finished: "This event has ended.",
    event_view_upcoming: "View upcoming events",
    reg_first_name: "First Name", reg_last_name: "Last Name", reg_email: "Email", reg_phone: "Phone",
    reg_participants: "No. of Participants", reg_message: "Message (optional)", reg_submit: "Register Now",
    reg_submitting: "Registering...", reg_required: "Please fill in all required fields.",
    reg_success_title: "Registration complete!", reg_success_msg: "Thank you for registering. We will contact you soon.",
    trainers_label: "Our experts", trainers_title: "International Trainers",
    trainers_view_all: "Meet our trainers", trainers_loading: "Loading...",
    cta_title: "Join Expert Panels and be part of Unique Events",
    cta_desc: "From hands-on workshops focused on the most advanced topics of digital orthodontics and aligner systems, to international virtual and physical conferences.",
    cta_contact: "Contact Us",
    faq_label: "Questions", faq_title: "Frequently Asked Questions",
    contact_title: "Contact", contact_subtitle: "Send us your questions or collaboration requests. We're here to help!",
    contact_info_title: "Contact Information", contact_form_title: "Contact Form",
    contact_address_label: "Address", contact_phone_label: "Phone", contact_email_label: "Email",
    contact_hours_label: "Hours", contact_hours_value: "Monday - Saturday | 08:00 - 17:00",
    contact_follow: "Follow Us", contact_follow_desc: "Follow us on social media for news and new events.",
    contact_name: "First Name", contact_surname: "Last Name", contact_subject: "Subject", contact_message: "Your message",
    contact_terms: "By continuing, I accept", contact_terms_link: "Terms of Use",
    contact_privacy_link: "Privacy Policy", contact_and: "and",
    contact_sending: "Sending...", contact_send: "Send",
    contact_success_title: "Thank you!", contact_success_msg: "Your message was sent successfully. We'll contact you soon.",
    contact_send_another: "Send another message",
    contact_error: "An error occurred. Please try again.",
    contact_required: "Please fill in all required fields.",
    footer_menu: "Menu", footer_upcoming: "Upcoming Events", footer_contact: "Contact",
    footer_no_events: "No upcoming events.", footer_brand: "The Albanian Aligner Academy for dentists, by dentists.",
    footer_rights: "All Rights Reserved", footer_powered: "Powered by",
    gallery_title: "Gallery", gallery_subtitle: "Moments from our events and trainings.",
    gallery_photos: "photos", gallery_empty: "No albums in gallery.",
    blog_title: "Blog", blog_subtitle: "Articles and news from the world of dentistry and aligners.",
    blog_read_more: "Read more", blog_empty: "No articles in the blog.",
    blog_back: "Back to Blog",
    about_page_title: "About Us",
    about_page_subtitle: "Get to know Albanian Aligners Academy - The Albanian Academy for Aligners.",
    // Auto-added multilingual keys
    hero_next_module_prefix: "Module",
    hero_countdown_days: "Days",
    hero_countdown_hours: "Hours",
    hero_countdown_min: "Min",
    hero_countdown_sec: "Sec",
    hero_masterclass_finished: "Masterclass completed",
    hero_masterclass_6modules: "6 Modules",
    hero_view_more: "View more",
    hero_starts_in: "STARTS IN:",
    home_upcoming_label: "Upcoming",
    home_upcoming_title: "Upcoming Events",
    home_upcoming_view_all: "View all",
    home_upcoming_click_to_select: "Click to select",
    tier_choose_package: "Choose a Package",
    tier_now_badge: "Now",
    tier_expired_badge: "Expired",
    tier_click_to_select: "Click to select",
    tier_package: "Package",
    event_topics_label: "Topics",
    event_topics_title: "Full Day Programme",
    event_speaker_label: "Speaker",
    event_date_label: "Date",
    event_location_label: "Location",
    event_schedule_label: "Schedule",
    event_price_label: "Price",
    register_now: "Register",
    register_now_full: "Register Now",
    buy_now: "Buy Now",
    register_processing: "Processing...",
    register_confirm: "Confirm Registration",
    register_continue_payment: "Continue to Payment",
    popup_event_price: "Event price",
    popup_saved: "Saved successfully",
    breadcrumb_home: "Home",
    breadcrumb_events: "Events",
    breadcrumb_upcoming: "Upcoming Events",
    breadcrumb_trainers: "Trainers",
    breadcrumb_privacy: "Privacy Policy",
    trainers_hero_desc: "International and local experts bringing exceptional experience to every training.",
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    free: "Free"
  },
  it: {
    nav_home: "Home", nav_about: "Chi Siamo", nav_events: "Eventi", nav_trainers: "Formatori",
    nav_gallery: "Galleria", nav_blog: "Blog", nav_contact: "Contatto",
    hero_welcome: "Benvenuti a", hero_brand: "Albanian Aligners Academy",
    hero_title: "L'Accademia Albanese degli Aligner per dentisti, dai dentisti.",
    hero_desc: "Albanian Aligners Academy e un simbolo di eccellenza nella terapia con aligner, offrendo formazione continua, mentoring esperto e un percorso di accreditamento certificato per i professionisti che vogliono eccellere nell'ortodonzia moderna.",
    hero_read_more: "Leggi di piu", hero_view_events: "Vedi eventi",
    stat_participants: "Partecipanti", stat_certifications: "Certificazioni", stat_events: "Eventi", stat_trainers: "Formatori Esperti",
    about_who: "Chi siamo", about_title: "Leader nella Formazione Professionale per Aligner in Albania e oltre",
    about_p1: "Mentre la scuola di odontoiatria fornisce una base per il trattamento dei singoli denti, molti dentisti si rendono presto conto che non li prepara completamente ad affrontare le cause profonde dei problemi dei pazienti. Coloro che seguono la formazione continua presso Albanian Aligners Academy descrivono l'esperienza come un momento di rivelazione e profondamente trasformativa.",
    about_p2: "Albanian Aligners Academy offre formazione specializzata, workshop pratici e formazione continua per i dentisti che vogliono approfondire le loro conoscenze nel campo degli aligner e dell'ortodonzia moderna.",
    events_label: "Eventi", events_upcoming: "Prossimi Eventi", events_past: "Eventi Passati", events_view_all: "Vedi tutti",
    events_no_upcoming: "Nessun evento imminente.", events_no_past: "Nessun evento passato.",
    event_upcoming_badge: "Prossimo", event_past_badge: "Passato", event_details: "Dettagli",
    event_next: "Prossimo Evento", event_days: "Giorni", event_hours: "Ore", event_min: "Min", event_sec: "Sec",
    events_hero_title: "Eventi",
    events_hero_desc: "Il nostro calendario di eventi dal vivo e pieno di occasioni uniche e formazione professionale vivace dove la conoscenza incontra la passione!",
    events_scroll_btn: "Vedi Eventi",
    events_join_title: "Unisciti ai Pannelli di Esperti e fai parte di Eventi Unici",
    events_meet_trainers: "INCONTRA I NOSTRI FORMATORI",
    events_cta_title: "Unisciti ai Pannelli di Esperti",
    events_cta_desc: "Dai workshop pratici alle conferenze internazionali - ogni evento e progettato per il tuo sviluppo professionale.",
    event_breadcrumb_home: "Home", event_breadcrumb_events: "Eventi", event_breadcrumb_detail: "Dettagli",
    event_description: "Descrizione dell'Evento", event_what_learn: "Cosa imparerai",
    event_who_for: "A chi e dedicato", event_agenda: "Agenda / Programma",
    event_register_title: "Registrati per questo Evento", event_finished: "Questo evento e terminato.",
    event_view_upcoming: "Vedi prossimi eventi",
    reg_first_name: "Nome", reg_last_name: "Cognome", reg_email: "Email", reg_phone: "Telefono",
    reg_participants: "N. Partecipanti", reg_message: "Messaggio (opzionale)", reg_submit: "Registrati Ora",
    reg_submitting: "Registrazione...", reg_required: "Compila tutti i campi obbligatori.",
    reg_success_title: "Registrazione completata!", reg_success_msg: "Grazie per la registrazione. Vi contatteremo presto.",
    trainers_label: "I nostri esperti", trainers_title: "Formatori Internazionali",
    trainers_view_all: "Incontra i nostri formatori", trainers_loading: "Caricamento...",
    cta_title: "Unisciti ai Pannelli di Esperti e fai parte di Eventi Unici",
    cta_desc: "Dai workshop pratici alle conferenze internazionali - ogni evento e progettato per il tuo sviluppo professionale.",
    cta_contact: "Contattaci",
    faq_label: "Domande", faq_title: "Domande Frequenti",
    contact_title: "Contatto", contact_subtitle: "Inviateci le vostre domande o richieste di collaborazione. Siamo qui per aiutarvi!",
    contact_info_title: "Informazioni di Contatto", contact_form_title: "Modulo di Contatto",
    contact_address_label: "Indirizzo", contact_phone_label: "Telefono", contact_email_label: "Email",
    contact_hours_label: "Orario", contact_hours_value: "Lunedi - Sabato | 08:00 - 17:00",
    contact_follow: "Seguici", contact_follow_desc: "Seguici sui social media per notizie e nuovi eventi.",
    contact_name: "Nome", contact_surname: "Cognome", contact_subject: "Oggetto", contact_message: "Il tuo messaggio",
    contact_terms: "Continuando, accetto", contact_terms_link: "Termini di Utilizzo",
    contact_privacy_link: "Politica sulla Privacy", contact_and: "e",
    contact_sending: "Invio...", contact_send: "Invia",
    contact_success_title: "Grazie!", contact_success_msg: "Il tuo messaggio e stato inviato con successo.",
    contact_send_another: "Invia un altro messaggio",
    contact_error: "Si e verificato un errore. Riprova.", contact_required: "Compila tutti i campi obbligatori.",
    footer_menu: "Menu", footer_upcoming: "Prossimi Eventi", footer_contact: "Contatto",
    footer_no_events: "Nessun evento imminente.", footer_brand: "L'Accademia Albanese degli Aligner per dentisti, dai dentisti.",
    footer_rights: "Tutti i Diritti Riservati", footer_powered: "Powered by",
    gallery_title: "Galleria", gallery_subtitle: "Momenti dai nostri eventi e formazioni.",
    gallery_photos: "foto", gallery_empty: "Nessun album nella galleria.",
    blog_title: "Blog", blog_subtitle: "Articoli e notizie dal mondo dell'odontoiatria e degli aligner.",
    blog_read_more: "Leggi di piu", blog_empty: "Nessun articolo nel blog.", blog_back: "Torna al Blog",
    about_page_title: "Chi Siamo", about_page_subtitle: "Conosci Albanian Aligners Academy.",
    events_hero_check: "Guarda in diretta. Impara diversamente. Scopri di più.",
    events_hero_italic: "Unisciti alla comunità di professionisti che cercano più di una semplice formazione.",
    events_hero_p2: "Da interviste con esperti internazionali, discussioni cliniche interattive, formati in stile TED, talk show dentali, fino a conferenze online e training dal vivo - ogni evento è progettato per ispirare, informare e migliorare la tua pratica clinica.",
    events_join_p1: "Albanian Aligners Academy arricchisce continuamente il proprio calendario con nuovi eventi, contenuti di valore e nuove opportunità di sviluppo professionale per ortodontisti, dentisti e tutti i professionisti del settore dentale.",
    events_join_p2: "Da workshop pratici focalizzati sui temi più avanzati dell'ortodonzia digitale e dei sistemi aligner, fino a conferenze internazionali virtuali e fisiche con la partecipazione di alcuni dei nomi più rinomati al mondo, l'accademia offre una piattaforma aperta per l'apprendimento, lo scambio di esperienze e la costruzione di una comunità.",
    events_join_p3: "Crediamo che la collaborazione professionale, l'artigianalità e l'accesso a conoscenze utilizzabili siano tra i fattori più importanti per lo sviluppo sostenibile di ogni professionista in odontoiatria e ortodonzia.",
    events_masterclass_dates: "Giugno - Ottobre 2026",
    events_masterclass_label: "Masterclass 2026",
    events_masterclass_modules: "6 Moduli",
    events_masterclass_sub: "Dai Fondamenti all'Eccellenza Full-Arch",
    events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_view: "Vedi i Moduli",
    home_masterclass_desc: "Il programma di implantologia più completo della regione. 6 moduli intensivi con oltre 9 esperti internazionali, dai fondamenti alla riabilitazione full-arch.",
    // Auto-added multilingual keys
    hero_next_module_prefix: "Modulo",
    hero_countdown_days: "Giorni",
    hero_countdown_hours: "Ore",
    hero_countdown_min: "Min",
    hero_countdown_sec: "Sec",
    hero_masterclass_finished: "Masterclass completata",
    hero_masterclass_6modules: "6 Moduli",
    hero_view_more: "Scopri di più",
    hero_starts_in: "INIZIA TRA:",
    home_upcoming_label: "In Arrivo",
    home_upcoming_title: "Prossimi eventi",
    home_upcoming_view_all: "Vedi tutti",
    home_upcoming_click_to_select: "Clicca per selezionare",
    tier_choose_package: "Scegli il pacchetto",
    tier_now_badge: "Ora",
    tier_expired_badge: "Scaduto",
    tier_click_to_select: "Clicca per selezionare",
    tier_package: "Pacchetto",
    event_topics_label: "Tematiche",
    event_topics_title: "Programma completo della giornata",
    event_speaker_label: "Relatore",
    event_date_label: "Data",
    event_location_label: "Luogo",
    event_schedule_label: "Orario",
    event_price_label: "Prezzo",
    register_now: "Registrati",
    register_now_full: "Registrati ora",
    buy_now: "Acquista ora",
    register_processing: "Elaborazione in corso...",
    register_confirm: "Conferma la registrazione",
    register_continue_payment: "Procedi al pagamento",
    popup_event_price: "Prezzo dell'evento",
    popup_saved: "Salvato con successo",
    breadcrumb_home: "Home",
    breadcrumb_events: "Eventi",
    breadcrumb_upcoming: "Prossimi eventi",
    breadcrumb_trainers: "Formatori",
    breadcrumb_privacy: "Informativa sulla privacy",
    trainers_hero_desc: "Esperti internazionali e locali che portano un'esperienza straordinaria in ogni corso di formazione.",
    close: "Chiudi",
    cancel: "Annulla",
    save: "Salva",
    free: "Gratuito"
  },
  de: {
    nav_home: "Startseite", nav_about: "Uber Uns", nav_events: "Veranstaltungen", nav_trainers: "Trainer",
    nav_gallery: "Galerie", nav_blog: "Blog", nav_contact: "Kontakt",
    hero_welcome: "Willkommen bei", hero_brand: "Albanian Aligners Academy",
    hero_title: "Die Albanische Aligner-Akademie fur Zahnarzte, von Zahnarzten.",
    hero_desc: "Albanian Aligners Academy ist ein Symbol fur Exzellenz in der Aligner-Therapie und bietet kontinuierliche Weiterbildung, Experten-Mentoring und einen zertifizierten Akkreditierungsweg fur Fachleute, die sich in der modernen Kieferorthopadie auszeichnen mochten.",
    hero_read_more: "Mehr lesen", hero_view_events: "Veranstaltungen ansehen",
    stat_participants: "Teilnehmer", stat_certifications: "Zertifizierungen", stat_events: "Veranstaltungen", stat_trainers: "Experten-Trainer",
    about_who: "Wer wir sind", about_title: "Fuhrend in der professionellen Ausbildung fur Aligner in Albanien und daruber hinaus",
    about_p1: "Wahrend die Zahnmedizinschule eine Grundlage fur die Behandlung einzelner Zahne bietet, erkennen viele Zahnarzte schnell, dass sie nicht vollstandig auf die Behandlung der Grundursachen von Patientenproblemen vorbereitet sind.",
    about_p2: "Albanian Aligners Academy bietet spezialisierte Schulungen, praktische Workshops und Weiterbildung fur Zahnarzte, die ihr Wissen im Bereich Aligner und moderner Kieferorthopadie vertiefen mochten.",
    events_label: "Veranstaltungen", events_upcoming: "Kommende Veranstaltungen", events_past: "Vergangene Veranstaltungen", events_view_all: "Alle ansehen",
    events_no_upcoming: "Keine bevorstehenden Veranstaltungen.", events_no_past: "Keine vergangenen Veranstaltungen.",
    event_upcoming_badge: "Kommend", event_past_badge: "Vergangen", event_details: "Details",
    event_next: "Nachste Veranstaltung", event_days: "Tage", event_hours: "Std", event_min: "Min", event_sec: "Sek",
    events_hero_title: "Veranstaltungen",
    events_hero_desc: "Unser Live-Veranstaltungskalender ist voll mit einzigartigen Gelegenheiten und lebendiger professioneller Weiterbildung!",
    events_scroll_btn: "Veranstaltungen ansehen",
    events_join_title: "Treten Sie Expertenpanels bei und werden Sie Teil einzigartiger Veranstaltungen",
    events_meet_trainers: "UNSERE TRAINER KENNENLERNEN",
    events_cta_title: "Expertenpanels beitreten", events_cta_desc: "Von praktischen Workshops bis zu internationalen Konferenzen.",
    event_breadcrumb_home: "Startseite", event_breadcrumb_events: "Veranstaltungen", event_breadcrumb_detail: "Details",
    event_description: "Veranstaltungsbeschreibung", event_what_learn: "Was Sie lernen werden",
    event_who_for: "Fur wen", event_agenda: "Agenda / Programm",
    event_register_title: "Fur diese Veranstaltung anmelden", event_finished: "Diese Veranstaltung ist beendet.",
    event_view_upcoming: "Kommende Veranstaltungen ansehen",
    reg_first_name: "Vorname", reg_last_name: "Nachname", reg_email: "E-Mail", reg_phone: "Telefon",
    reg_participants: "Anzahl Teilnehmer", reg_message: "Nachricht (optional)", reg_submit: "Jetzt anmelden",
    reg_submitting: "Anmeldung...", reg_required: "Bitte fullen Sie alle Pflichtfelder aus.",
    reg_success_title: "Anmeldung abgeschlossen!", reg_success_msg: "Vielen Dank. Wir werden Sie bald kontaktieren.",
    trainers_label: "Unsere Experten", trainers_title: "Internationale Trainer",
    trainers_view_all: "Unsere Trainer kennenlernen", trainers_loading: "Laden...",
    cta_title: "Treten Sie Expertenpanels bei", cta_desc: "Von praktischen Workshops bis zu internationalen Konferenzen.", cta_contact: "Kontaktieren Sie uns",
    faq_label: "Fragen", faq_title: "Haufig gestellte Fragen",
    contact_title: "Kontakt", contact_subtitle: "Senden Sie uns Ihre Fragen oder Kooperationsanfragen. Wir sind hier, um zu helfen!",
    contact_info_title: "Kontaktinformationen", contact_form_title: "Kontaktformular",
    contact_address_label: "Adresse", contact_phone_label: "Telefon", contact_email_label: "E-Mail",
    contact_hours_label: "Offnungszeiten", contact_hours_value: "Montag - Samstag | 08:00 - 17:00",
    contact_follow: "Folgen Sie uns", contact_follow_desc: "Folgen Sie uns in sozialen Medien.",
    contact_name: "Vorname", contact_surname: "Nachname", contact_subject: "Betreff", contact_message: "Ihre Nachricht",
    contact_terms: "Mit dem Fortfahren akzeptiere ich", contact_terms_link: "Nutzungsbedingungen",
    contact_privacy_link: "Datenschutzrichtlinie", contact_and: "und",
    contact_sending: "Senden...", contact_send: "Senden",
    contact_success_title: "Vielen Dank!", contact_success_msg: "Ihre Nachricht wurde erfolgreich gesendet.",
    contact_send_another: "Weitere Nachricht senden",
    contact_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.", contact_required: "Bitte fullen Sie alle Pflichtfelder aus.",
    footer_menu: "Menu", footer_upcoming: "Kommende Veranstaltungen", footer_contact: "Kontakt",
    footer_no_events: "Keine bevorstehenden Veranstaltungen.", footer_brand: "Die Albanische Aligner-Akademie fur Zahnarzte, von Zahnarzten.",
    footer_rights: "Alle Rechte vorbehalten", footer_powered: "Powered by",
    gallery_title: "Galerie", gallery_subtitle: "Momente aus unseren Veranstaltungen.", gallery_photos: "Fotos", gallery_empty: "Keine Alben.",
    blog_title: "Blog", blog_subtitle: "Artikel und Nachrichten aus der Welt der Zahnmedizin.",
    blog_read_more: "Mehr lesen", blog_empty: "Keine Artikel.", blog_back: "Zuruck zum Blog",
    about_page_title: "Uber Uns", about_page_subtitle: "Lernen Sie Albanian Aligners Academy kennen.",
    events_hero_check: "Live ansehen. Anders lernen. Mehr entdecken.",
    events_hero_italic: "Schließen Sie sich der Gemeinschaft von Fachleuten an, die mehr suchen als nur Schulungen.",
    events_hero_p2: "Von Interviews mit internationalen Experten, interaktiven klinischen Diskussionen, TED-ähnlichen Formaten und Dental-Talkshows bis hin zu Online-Konferenzen und Live-Schulungen - jede Veranstaltung wurde entwickelt, um zu inspirieren, zu informieren und Ihre klinische Praxis zu verbessern.",
    events_join_p1: "Albanian Aligners Academy bereichert ihren Kalender kontinuierlich mit neuen Veranstaltungen, wertvollen Inhalten und neuen beruflichen Entwicklungsmöglichkeiten für Kieferorthopäden, Zahnärzte und alle Fachleute der Dentalbranche.",
    events_join_p2: "Von praktischen Workshops zu den fortschrittlichsten Themen der digitalen Kieferorthopädie und Aligner-Systeme bis hin zu internationalen virtuellen und physischen Konferenzen mit einigen der weltweit bekanntesten Namen bietet die Akademie eine offene Plattform für Lernen, Erfahrungsaustausch und Community-Aufbau.",
    events_join_p3: "Wir glauben, dass berufliche Zusammenarbeit, Handwerkskunst und der Zugang zu nutzbarem Wissen zu den wichtigsten Faktoren für die nachhaltige Entwicklung jedes Fachmanns in der Zahnmedizin und Kieferorthopädie gehören.",
    events_masterclass_dates: "Juni - Oktober 2026",
    events_masterclass_label: "Masterclass 2026",
    events_masterclass_modules: "6 Module",
    events_masterclass_sub: "Von den Grundlagen bis zur Full-Arch-Exzellenz",
    events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_view: "Module ansehen",
    home_masterclass_desc: "Das umfassendste Implantologie-Programm in der Region. 6 intensive Module mit über 9 internationalen Experten, von den Grundlagen bis zur Full-Arch-Rehabilitation.",
    // Auto-added multilingual keys
    hero_next_module_prefix: "Modul",
    hero_countdown_days: "Tage",
    hero_countdown_hours: "Stunden",
    hero_countdown_min: "Min",
    hero_countdown_sec: "Sek",
    hero_masterclass_finished: "Masterclass abgeschlossen",
    hero_masterclass_6modules: "6 Module",
    hero_view_more: "Mehr anzeigen",
    hero_starts_in: "BEGINNT IN:",
    home_upcoming_label: "Bevorstehend",
    home_upcoming_title: "Bevorstehende Veranstaltungen",
    home_upcoming_view_all: "Alle anzeigen",
    home_upcoming_click_to_select: "Zum Auswählen klicken",
    tier_choose_package: "Paket wählen",
    tier_now_badge: "Jetzt",
    tier_expired_badge: "Abgelaufen",
    tier_click_to_select: "Zum Auswählen klicken",
    tier_package: "Paket",
    event_topics_label: "Themen",
    event_topics_title: "Das vollständige Tagesprogramm",
    event_speaker_label: "Referent",
    event_date_label: "Datum",
    event_location_label: "Ort",
    event_schedule_label: "Zeitplan",
    event_price_label: "Preis",
    register_now: "Jetzt anmelden",
    register_now_full: "Jetzt anmelden",
    buy_now: "Jetzt kaufen",
    register_processing: "Wird verarbeitet...",
    register_confirm: "Anmeldung bestätigen",
    register_continue_payment: "Weiter zur Zahlung",
    popup_event_price: "Veranstaltungspreis",
    popup_saved: "Erfolgreich gespeichert",
    breadcrumb_home: "Startseite",
    breadcrumb_events: "Veranstaltungen",
    breadcrumb_upcoming: "Bevorstehende Veranstaltungen",
    breadcrumb_trainers: "Trainer",
    breadcrumb_privacy: "Datenschutzrichtlinie",
    trainers_hero_desc: "Internationale und lokale Experten, die bei jedem Training außergewöhnliche Erfahrung einbringen.",
    close: "Schließen",
    cancel: "Abbrechen",
    save: "Speichern",
    free: "Kostenlos"
  },
  fr: {
    nav_home: "Accueil", nav_about: "A Propos", nav_events: "Evenements", nav_trainers: "Formateurs",
    nav_gallery: "Galerie", nav_blog: "Blog", nav_contact: "Contact",
    hero_welcome: "Bienvenue a", hero_brand: "Albanian Aligners Academy",
    hero_title: "L'Academie Albanaise des Aligneurs pour les dentistes, par les dentistes.",
    hero_desc: "Albanian Aligners Academy est un symbole d'excellence en therapie par aligneurs, offrant une formation continue, un mentorat expert et un parcours d'accreditation certifie.",
    hero_read_more: "En savoir plus", hero_view_events: "Voir les evenements",
    stat_participants: "Participants", stat_certifications: "Certifications", stat_events: "Evenements", stat_trainers: "Formateurs Experts",
    about_who: "Qui sommes-nous", about_title: "Leaders de la Formation Professionnelle pour les Aligneurs en Albanie et au-dela",
    about_p1: "Alors que l'ecole dentaire fournit une base pour le traitement des dents individuelles, de nombreux dentistes realisent rapidement qu'elle ne les prepare pas completement.",
    about_p2: "Albanian Aligners Academy propose des formations specialisees, des ateliers pratiques et une formation continue pour les dentistes.",
    events_label: "Evenements", events_upcoming: "Prochains Evenements", events_past: "Evenements Passes", events_view_all: "Voir tout",
    events_no_upcoming: "Aucun evenement a venir.", events_no_past: "Aucun evenement passe.",
    event_upcoming_badge: "A venir", event_past_badge: "Passe", event_details: "Details",
    event_next: "Prochain Evenement", event_days: "Jours", event_hours: "Hrs", event_min: "Min", event_sec: "Sec",
    events_hero_title: "Evenements", events_hero_desc: "Notre calendrier d'evenements en direct est rempli d'occasions uniques!",
    events_scroll_btn: "Voir les Evenements",
    events_join_title: "Rejoignez les Panels d'Experts", events_meet_trainers: "RENCONTREZ NOS FORMATEURS",
    events_cta_title: "Rejoignez les Panels d'Experts", events_cta_desc: "Des ateliers pratiques aux conferences internationales.",
    event_breadcrumb_home: "Accueil", event_breadcrumb_events: "Evenements", event_breadcrumb_detail: "Details",
    event_description: "Description de l'Evenement", event_what_learn: "Ce que vous apprendrez",
    event_who_for: "A qui s'adresse-t-il", event_agenda: "Agenda / Programme",
    event_register_title: "Inscrivez-vous", event_finished: "Cet evenement est termine.",
    event_view_upcoming: "Voir les prochains evenements",
    reg_first_name: "Prenom", reg_last_name: "Nom", reg_email: "Email", reg_phone: "Telephone",
    reg_participants: "Nb de Participants", reg_message: "Message (optionnel)", reg_submit: "S'inscrire Maintenant",
    reg_submitting: "Inscription...", reg_required: "Veuillez remplir tous les champs obligatoires.",
    reg_success_title: "Inscription terminee!", reg_success_msg: "Merci pour votre inscription. Nous vous contacterons bientot.",
    trainers_label: "Nos experts", trainers_title: "Formateurs Internationaux",
    trainers_view_all: "Rencontrez nos formateurs", trainers_loading: "Chargement...",
    cta_title: "Rejoignez les Panels d'Experts", cta_desc: "Des ateliers pratiques aux conferences internationales.", cta_contact: "Contactez-nous",
    faq_label: "Questions", faq_title: "Questions Frequentes",
    contact_title: "Contact", contact_subtitle: "Envoyez-nous vos questions. Nous sommes la pour vous aider!",
    contact_info_title: "Informations de Contact", contact_form_title: "Formulaire de Contact",
    contact_address_label: "Adresse", contact_phone_label: "Telephone", contact_email_label: "Email",
    contact_hours_label: "Horaires", contact_hours_value: "Lundi - Samedi | 08:00 - 17:00",
    contact_follow: "Suivez-nous", contact_follow_desc: "Suivez-nous sur les reseaux sociaux.",
    contact_name: "Prenom", contact_surname: "Nom", contact_subject: "Sujet", contact_message: "Votre message",
    contact_terms: "En continuant, j'accepte", contact_terms_link: "Conditions d'Utilisation",
    contact_privacy_link: "Politique de Confidentialite", contact_and: "et",
    contact_sending: "Envoi...", contact_send: "Envoyer",
    contact_success_title: "Merci!", contact_success_msg: "Votre message a ete envoye avec succes.",
    contact_send_another: "Envoyer un autre message",
    contact_error: "Une erreur est survenue.", contact_required: "Veuillez remplir tous les champs obligatoires.",
    footer_menu: "Menu", footer_upcoming: "Prochains Evenements", footer_contact: "Contact",
    footer_no_events: "Aucun evenement a venir.", footer_brand: "L'Academie Albanaise des Aligneurs pour les dentistes, par les dentistes.",
    footer_rights: "Tous Droits Reserves", footer_powered: "Powered by",
    gallery_title: "Galerie", gallery_subtitle: "Moments de nos evenements.", gallery_photos: "photos", gallery_empty: "Aucun album.",
    blog_title: "Blog", blog_subtitle: "Articles et actualites du monde dentaire.",
    blog_read_more: "Lire la suite", blog_empty: "Aucun article.", blog_back: "Retour au Blog",
    about_page_title: "A Propos", about_page_subtitle: "Decouvrez Albanian Aligners Academy.",
    events_hero_check: "Regardez en direct. Apprenez différemment. Découvrez davantage.",
    events_hero_italic: "Rejoignez la communauté de professionnels qui cherchent plus qu'une simple formation.",
    events_hero_p2: "Des interviews d'experts internationaux, discussions cliniques interactives, formats de style TED, talk-shows dentaires, jusqu'aux conférences en ligne et formations en direct - chaque événement est conçu pour inspirer, informer et améliorer votre pratique clinique.",
    events_join_p1: "Albanian Aligners Academy enrichit continuellement son calendrier avec de nouveaux événements, du contenu précieux et de nouvelles opportunités de développement professionnel pour les orthodontistes, dentistes et tous les professionnels du domaine dentaire.",
    events_join_p2: "Des ateliers pratiques axés sur les sujets les plus avancés de l'orthodontie numérique et des systèmes aligneurs, aux conférences internationales virtuelles et physiques avec la participation de certains des noms les plus renommés au monde, l'académie offre une plateforme ouverte pour l'apprentissage, le partage d'expériences et la construction d'une communauté.",
    events_join_p3: "Nous croyons que la collaboration professionnelle, le savoir-faire et l'accès à des connaissances utilisables figurent parmi les facteurs les plus importants pour le développement durable de chaque professionnel en dentisterie et orthodontie.",
    events_masterclass_dates: "Juin - Octobre 2026",
    events_masterclass_label: "Masterclass 2026",
    events_masterclass_modules: "6 Modules",
    events_masterclass_sub: "Des Fondamentaux à l'Excellence Full-Arch",
    events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_view: "Voir les Modules",
    home_masterclass_desc: "Le programme d'implantologie le plus complet de la région. 6 modules intensifs avec plus de 9 experts internationaux, des fondamentaux à la réhabilitation full-arch.",
    // Auto-added multilingual keys
    hero_next_module_prefix: "Module",
    hero_countdown_days: "Jours",
    hero_countdown_hours: "Heures",
    hero_countdown_min: "Min",
    hero_countdown_sec: "Sec",
    hero_masterclass_finished: "Masterclass terminée",
    hero_masterclass_6modules: "6 Modules",
    hero_view_more: "Voir plus",
    hero_starts_in: "COMMENCE DANS :",
    home_upcoming_label: "À venir",
    home_upcoming_title: "Événements à venir",
    home_upcoming_view_all: "Voir tout",
    home_upcoming_click_to_select: "Cliquez pour sélectionner",
    tier_choose_package: "Choisir le forfait",
    tier_now_badge: "Maintenant",
    tier_expired_badge: "Expiré",
    tier_click_to_select: "Cliquez pour sélectionner",
    tier_package: "Forfait",
    event_topics_label: "Thématiques",
    event_topics_title: "Programme complet de la journée",
    event_speaker_label: "Intervenant",
    event_date_label: "Date",
    event_location_label: "Lieu",
    event_schedule_label: "Horaire",
    event_price_label: "Prix",
    register_now: "S'inscrire",
    register_now_full: "S'inscrire maintenant",
    buy_now: "Acheter maintenant",
    register_processing: "Traitement en cours...",
    register_confirm: "Confirmer l'inscription",
    register_continue_payment: "Continuer vers le paiement",
    popup_event_price: "Prix de l'événement",
    popup_saved: "Enregistré avec succès",
    breadcrumb_home: "Accueil",
    breadcrumb_events: "Événements",
    breadcrumb_upcoming: "Événements à venir",
    breadcrumb_trainers: "Formateurs",
    breadcrumb_privacy: "Politique de confidentialité",
    trainers_hero_desc: "Des experts internationaux et locaux qui apportent une expérience exceptionnelle à chaque formation.",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    free: "Gratuit"
  },
  mk: {
    nav_home: "Pocetna", nav_about: "Za Nas", nav_events: "Nastani", nav_trainers: "Treneri",
    nav_gallery: "Galerija", nav_blog: "Blog", nav_contact: "Kontakt",
    hero_welcome: "Dobrodojdovte vo", hero_brand: "Albanian Aligners Academy",
    hero_title: "Albanskata Akademija za Aligneri za zabari, od zabari.",
    hero_desc: "Albanian Aligners Academy e simbol na izvonrednost vo terapijata so aligneri, nudeJKi kontinuirana edukacija, mentorstvo od eksperti i sertificiran pat za akreditacija.",
    hero_read_more: "Procitajte poveke", hero_view_events: "Pogledni nastani",
    stat_participants: "Ucesnici", stat_certifications: "Sertifikati", stat_events: "Nastani", stat_trainers: "Ekspert Treneri",
    about_who: "Koj sme nie", about_title: "Lideri vo profesionalnata edukacija za aligneri vo Albanija i ponatamu",
    about_p1: "Dodeka zabolekarskoto uciliste pruza osnova za lekuvanje na poedineeni zabi, mnogu zabari brzo sfakaat deka ne gi podgotvuva celosno za adresiranje na osnovnite pricini na problemite na pacientite.",
    about_p2: "Albanian Aligners Academy nudi specijalizirani obuki, prakticki rabotilnici i kontinuirana edukacija za zabarite koi sakaat da gi prodlabocuvaat svoite znaenja.",
    events_label: "Nastani", events_upcoming: "Predstojni Nastani", events_past: "Izminati Nastani", events_view_all: "Pogledni site",
    events_no_upcoming: "Nema predstojni nastani.", events_no_past: "Nema izminati nastani.",
    event_upcoming_badge: "Predstoen", event_past_badge: "Izminat", event_details: "Detali",
    event_next: "Sleden Nastan", event_days: "Dena", event_hours: "Casa", event_min: "Min", event_sec: "Sek",
    events_hero_title: "Nastani", events_hero_desc: "Nasiot kalendar na nastani e poln so unikatni pridonesi i profesionalna edukacija!",
    events_scroll_btn: "Pogledni Nastani",
    events_join_title: "Pridruzete se na ekspertski paneli", events_meet_trainers: "ZAPOZNAJTE GI NASITE TRENERI",
    events_cta_title: "Pridruzete se na ekspertski paneli", events_cta_desc: "Od prakticki rabotilnici do meGunarodni konferencii.",
    event_breadcrumb_home: "Pocetna", event_breadcrumb_events: "Nastani", event_breadcrumb_detail: "Detali",
    event_description: "Opis na Nastanot", event_what_learn: "Sto kje naucite",
    event_who_for: "Za kogo e nameneto", event_agenda: "Agenda / Programa",
    event_register_title: "Registrirajte se za ovoj nastan", event_finished: "Ovoj nastan zavrsi.",
    event_view_upcoming: "Pogledni predstojni nastani",
    reg_first_name: "Ime", reg_last_name: "Prezime", reg_email: "Email", reg_phone: "Telefon",
    reg_participants: "Br. ucesnici", reg_message: "Poraka (opciono)", reg_submit: "Registriraj se sega",
    reg_submitting: "Registracija...", reg_required: "Ve molime popolnete gi site zadolzitelni poinja.",
    reg_success_title: "Registracijata zavrsi!", reg_success_msg: "Blagodrime. Kje ve kontaktirame naSkoro.",
    trainers_label: "Nasite eksperti", trainers_title: "Megunarodni Treneri",
    trainers_view_all: "Zapoznajte gi nasite treneri", trainers_loading: "Vcituvanje...",
    cta_title: "Pridruzete se na ekspertski paneli", cta_desc: "Od prakticki rabotilnici do meGunarodni konferencii.", cta_contact: "Kontaktirajte ne",
    faq_label: "Prasanja", faq_title: "Cesto Postavuvani Prasanja",
    contact_title: "Kontakt", contact_subtitle: "Ispratete ni gi vasiti prasanja. Tuka sme da pomogneme!",
    contact_info_title: "Kontakt Informacii", contact_form_title: "Kontakt Forma",
    contact_address_label: "Adresa", contact_phone_label: "Telefon", contact_email_label: "Email",
    contact_hours_label: "Rabotno vreme", contact_hours_value: "Ponedelnik - Sabota | 08:00 - 17:00",
    contact_follow: "Sledete ne", contact_follow_desc: "Sledete ne na socijalnite mrezi.",
    contact_name: "Ime", contact_surname: "Prezime", contact_subject: "Naslov", contact_message: "Vasa poraka",
    contact_terms: "Prodolzuvajki, jas prifakam", contact_terms_link: "Uslovi za koristenje",
    contact_privacy_link: "Politika za privatnost", contact_and: "i",
    contact_sending: "Isprakanje...", contact_send: "Isprati",
    contact_success_title: "Blagodrime!", contact_success_msg: "Vasata poraka e uspesno ispratena.",
    contact_send_another: "Isprati druga poraka",
    contact_error: "Se slucsi greska.", contact_required: "Popolnete gi site zadolzitelni poinja.",
    footer_menu: "Meni", footer_upcoming: "Predstojni Nastani", footer_contact: "Kontakt",
    footer_no_events: "Nema predstojni nastani.", footer_brand: "Albanskata Akademija za Aligneri za zabari, od zabari.",
    footer_rights: "Site prava zadrzani", footer_powered: "Powered by",
    gallery_title: "Galerija", gallery_subtitle: "Momenti od nasite nastani.", gallery_photos: "fotki", gallery_empty: "Nema albumi.",
    blog_title: "Blog", blog_subtitle: "Statii i vesti od svetot na stomatologijata.",
    blog_read_more: "Procitajte poveke", blog_empty: "Nema statii.", blog_back: "Nazad kon Blog",
    about_page_title: "Za Nas", about_page_subtitle: "Zapoznajte ja Albanian Aligners Academy.",
    events_hero_check: "Gledajte vo zhivo. Uchete poinaku. Otkrijte poveke.",
    events_hero_italic: "Pridruzhete se na zaednicata na profesionalci shto baraat poveke od samo obuka.",
    events_hero_p2: "Od intervjua so megjunarodni eksperti, interaktivni klinichki diskusii, TED-stil formati, dentalni talk show, do online konferencii i obuki vo zhivo - sekoj nastan e dizajniran da inspirira, informira i ja podobri vashata klinichka praksa.",
    events_join_p1: "Albanian Aligners Academy postojano go zbogatuva svoj kalendar so novi nastani, sodrzhini so vrednost i novi mozhnosti za profesionalen razvoj za ortodontite, dentistite i site profesionalci od dentalnata oblast.",
    events_join_p2: "Od prakticni rabotilnici fokusirani na najnaprednite temi od digitalnata ortodoncija i aligner sistemite, do megjunarodni virtuelni i fizichki konferencii so uchestvo na nekoi od najpoznatite svetski iminja, akademijata nudi otvorena platforma za uchenje, razmena na iskustva i izgradba na zaednica.",
    events_join_p3: "Veruvame deka profesionalnata sorabotka, zanaeticheskata umenost i pristapot do upotreblivi znaenja se megju najvazhnite faktori za odrzhliv razvoj na sekoj profesionalec vo stomatologijata i ortodoncija.",
    events_masterclass_dates: "Juni - Oktomvri 2026",
    events_masterclass_label: "Masterclass 2026",
    events_masterclass_modules: "6 Moduli",
    events_masterclass_sub: "Od osnovite do Full-Arch ekselentnost",
    events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_view: "Vidi Moduli",
    home_masterclass_desc: "Најкомплетната програма за имплантологија во регионот. 6 интензивни модули со над 9 меѓународни експерти, од основите до full-arch рехабилитацијата.",
    // Auto-added multilingual keys
    hero_next_module_prefix: "Модул",
    hero_countdown_days: "Денови",
    hero_countdown_hours: "Часови",
    hero_countdown_min: "Мин",
    hero_countdown_sec: "Сек",
    hero_masterclass_finished: "Masterclass завршен",
    hero_masterclass_6modules: "6 Модули",
    hero_view_more: "Погледни повеќе",
    hero_starts_in: "ЗАПОЧНУВА ЗА:",
    home_upcoming_label: "Претстојни",
    home_upcoming_title: "Претстојни настани",
    home_upcoming_view_all: "Погледни ги сите",
    home_upcoming_click_to_select: "Кликнете за да изберете",
    tier_choose_package: "Изберете пакет",
    tier_now_badge: "Сега",
    tier_expired_badge: "Истечен",
    tier_click_to_select: "Кликнете за да изберете",
    tier_package: "Paket",
    event_topics_label: "Теми",
    event_topics_title: "Целосна програма на денот",
    event_speaker_label: "Предавач",
    event_date_label: "Датум",
    event_location_label: "Локација",
    event_schedule_label: "Распоред",
    event_price_label: "Цена",
    register_now: "Регистрирај се",
    register_now_full: "Регистрирај се сега",
    buy_now: "Купи сега",
    register_processing: "Се обработува...",
    register_confirm: "Потврди регистрација",
    register_continue_payment: "Продолжи со плаќање",
    popup_event_price: "Цена на настанот",
    popup_saved: "Успешно зачувано",
    breadcrumb_home: "Почетна",
    breadcrumb_events: "Настани",
    breadcrumb_upcoming: "Претстојни настани",
    breadcrumb_trainers: "Тренери",
    breadcrumb_privacy: "Политика за приватност",
    trainers_hero_desc: "Меѓународни и домашни експерти кои носат исклучително искуство на секоја обука.",
    close: "Затвори",
    cancel: "Откажи",
    save: "Зачувај",
    free: "Бесплатно"
  },
  el: {
    nav_home: "Αρχική Σελίδα",
    nav_about: "Σχετικά με Εμάς",
    nav_events: "Εκδηλώσεις",
    nav_trainers: "Εκπαιδευτές",
    nav_gallery: "Γκαλερί",
    nav_blog: "Blog",
    nav_contact: "Επικοινωνία",
    hero_welcome: "Καλωσορίσατε στο",
    hero_brand: "Albanian Aligners Academy",
    hero_title: "Η Αλβανική Ακαδημία Aligner για οδοντιάτρους, από οδοντιάτρους.",
    hero_desc: "Η Albanian Aligners Academy αποτελεί σύμβολο αριστείας στη θεραπεία με aligners, προσφέροντας συνεχιζόμενη εκπαίδευση, καθοδήγηση από ειδικούς και μια πιστοποιημένη διαδρομή διαπίστευσης για επαγγελματίες που επιθυμούν να διακριθούν στη σύγχρονη ορθοδοντική.",
    hero_read_more: "Διαβάστε περισσότερα",
    hero_view_events: "Δείτε τις εκδηλώσεις",
    stat_participants: "Συμμετέχοντες",
    stat_certifications: "Πιστοποιήσεις",
    stat_events: "Εκδηλώσεις",
    stat_trainers: "Ειδικευμένοι Εκπαιδευτές",
    about_who: "Ποιοι είμαστε",
    about_title: "Πρωτοπόροι στην Επαγγελματική Εκπαίδευση για Aligners στην Αλβανία και πέρα από αυτήν",
    about_p1: "Ενώ η οδοντιατρική σχολή παρέχει μια βάση για τη θεραπεία μεμονωμένων δοντιών, πολλοί οδοντίατροι συνειδητοποιούν γρήγορα ότι δεν τους προετοιμάζει πλήρως για την αντιμετώπιση των βαθύτερων αιτιών των προβλημάτων των ασθενών. Όσοι παρακολουθούν τη συνεχιζόμενη εκπαίδευση στην Albanian Aligners Academy την περιγράφουν ως «άνοιγμα ματιών» και βαθιά μεταμορφωτική εμπειρία, με καθοριστικές στιγμές που αλλάζουν ριζικά την προσέγγισή τους στην οδοντιατρική φροντίδα.",
    about_p2: "Η Albanian Aligners Academy προσφέρει εξειδικευμένες εκπαιδεύσεις, πρακτικά workshops και συνεχιζόμενη εκπαίδευση για οδοντιάτρους που επιθυμούν να εμβαθύνουν τις γνώσεις τους στον τομέα των aligners και της σύγχρονης ορθοδοντικής.",
    events_label: "Εκδηλώσεις",
    events_upcoming: "Επερχόμενες Εκδηλώσεις",
    events_past: "Παρελθοντικές Εκδηλώσεις",
    events_view_all: "Δείτε όλα",
    events_no_upcoming: "Δεν υπάρχουν προσεχείς εκδηλώσεις αυτή τη στιγμή.",
    events_no_past: "Δεν υπάρχουν παρελθοντικές εκδηλώσεις.",
    event_upcoming_badge: "Προσεχής",
    event_past_badge: "Παρελθοντική",
    event_details: "Λεπτομέρειες",
    event_next: "Επόμενη Εκδήλωση",
    event_days: "Ημέρες",
    event_hours: "Ώρες",
    event_min: "Λεπτά",
    event_sec: "Δευτερόλεπτα",
    events_hero_title: "Εκδηλώσεις",
    events_hero_desc: "Το ζωντανό ημερολόγιο εκδηλώσεών μας είναι γεμάτο με μοναδικές δραστηριότητες και ζωντανή επαγγελματική εκπαίδευση, όπου η γνώση συναντά το πάθος!",
    events_hero_p2: "Από συνεντεύξεις με διεθνείς εμπειρογνώμονες, διαδραστικές κλινικές συζητήσεις, παρουσιάσεις στυλ TED, οδοντιατρικά talk show, έως διαδικτυακά συνέδρια και live εκπαιδεύσεις — κάθε εκδήλωση σχεδιάζεται για να εμπνέει, να ενημερώνει και να βελτιώνει την κλινική σας πρακτική.",
    events_hero_check: "Παρακολουθήστε live. Μάθετε διαφορετικά. Ανακαλύψτε περισσότερα.",
    events_hero_italic: "Γίνετε μέλος της κοινότητας επαγγελματιών που αναζητούν κάτι περισσότερο από μια απλή εκπαίδευση.",
    events_scroll_btn: "Δείτε τις Εκδηλώσεις",
    events_masterclass_label: "Masterclass 2026",
    events_masterclass_title: "Modern Implantology Masterclass",
    events_masterclass_sub: "From Fundamentals to Full-Arch Excellence",
    events_masterclass_modules: "6 Ενότητες",
    events_masterclass_dates: "Ιούνιος - Οκτώβριος 2026",
    events_masterclass_view: "Δείτε τις Ενότητες",
    home_masterclass_desc: "Το πληρέστερο πρόγραμμα εμφυτευματολογίας στην περιοχή. 6 εντατικές ενότητες με 9+ διεθνείς εμπειρογνώμονες, από τις βάσεις έως την αποκατάσταση full-arch.",
    events_join_title: "Συμμετέχετε σε Panels με Ειδικούς και γίνετε μέρος Μοναδικών Events",
    events_join_p1: "Η Albanian Aligners Academy εμπλουτίζει συνεχώς το ημερολόγιό της με νέες εκδηλώσεις, πολύτιμο περιεχόμενο και νέες ευκαιρίες επαγγελματικής ανάπτυξης για ορθοδοντικούς, οδοντιάτρους και όλους τους επαγγελματίες του οδοντιατρικού κλάδου.",
    events_join_p2: "Από hands-on workshops εστιασμένα στα πιο προηγμένα θέματα ψηφιακής ορθοδοντικής και συστημάτων aligner, έως διεθνή συνέδρια — διαδικτυακά και φυσικής παρουσίας — με τη συμμετοχή μερικών από τα πιο γνωστά ονόματα παγκοσμίως, η ακαδημία προσφέρει μια ανοιχτή πλατφόρμα για μάθηση, ανταλλαγή εμπειριών και οικοδόμηση κοινότητας.",
    events_join_p3: "Πιστεύουμε ότι η επαγγελματική συνεργασία, η διαμεσολάβηση και η πρόσβαση σε πρακτικές γνώσεις είναι από τους πιο σημαντικούς παράγοντες για τη βιώσιμη ανάπτυξη κάθε επαγγελματία στην οδοντιατρική και ορθοδοντική. Αυτός είναι ο λόγος που κάθε εκδήλωση που διοργανώνουμε εστιάζει όχι μόνο στη θεωρητική και τεχνολογική πτυχή, αλλά και στην οικοδόμηση μιας κουλτούρας συνεργασίας και αφοσίωσης στην κλινική αριστεία.",
    events_meet_trainers: "ΓΝΩΡΙΣΤΕ ΤΟΥΣ ΕΚΠΑΙΔΕΥΤΕΣ ΜΑΣ",
    events_cta_title: "Συμμετέχετε σε Panels με Εμπειρογνώμονες",
    events_cta_desc: "Από hands-on workshops έως διεθνή συνέδρια — κάθε εκδήλωση σχεδιάζεται για την επαγγελματική σας ανάπτυξη.",
    event_breadcrumb_home: "Αρχική Σελίδα",
    event_breadcrumb_events: "Εκδηλώσεις",
    event_breadcrumb_detail: "Λεπτομέρειες",
    event_description: "Περιγραφή Εκδήλωσης",
    event_what_learn: "Τι θα διδαχθείτε",
    event_who_for: "Σε ποιους απευθύνεται",
    event_agenda: "Ατζέντα / Πρόγραμμα",
    event_register_title: "Εγγραφείτε για αυτό το Event",
    event_finished: "Αυτό το event έχει ολοκληρωθεί.",
    event_view_upcoming: "Δείτε τα επερχόμενα events",
    reg_first_name: "Όνομα",
    reg_last_name: "Επώνυμο",
    reg_email: "Email",
    reg_phone: "Τηλέφωνο",
    reg_participants: "Αρ. Συμμετεχόντων",
    reg_message: "Μήνυμα (προαιρετικό)",
    reg_submit: "Εγγραφή Τώρα",
    reg_submitting: "Γίνεται εγγραφή...",
    reg_required: "Παρακαλώ συμπληρώστε τα υποχρεωτικά πεδία.",
    reg_success_title: "Η εγγραφή ολοκληρώθηκε!",
    reg_success_msg: "Ευχαριστούμε για την εγγραφή σας. Θα επικοινωνήσουμε μαζί σας σύντομα.",
    trainers_label: "Οι ειδικοί μας",
    trainers_title: "Διεθνείς Εκπαιδευτές",
    trainers_view_all: "Γνωρίστε τους εκπαιδευτές μας",
    trainers_loading: "Φόρτωση...",
    cta_title: "Συμμετέχετε σε Panels με Ειδικούς και γίνετε μέρος Μοναδικών Events",
    cta_desc: "Από πρακτικά workshops εστιασμένα στα πιο προηγμένα θέματα της ψηφιακής ορθοδοντικής και του συστήματος aligner, έως διεθνή συνέδρια σε διαδικτυακή και φυσική μορφή.",
    cta_contact: "Επικοινωνήστε μαζί μας",
    faq_label: "Ερωτήσεις",
    faq_title: "Συχνές ερωτήσεις",
    contact_title: "Επικοινωνία",
    contact_subtitle: "Στείλτε μας τις ερωτήσεις σας ή τα αιτήματα συνεργασίας. Είμαστε εδώ για να σας βοηθήσουμε!",
    contact_info_title: "Στοιχεία Επικοινωνίας",
    contact_form_title: "Φόρμα Επικοινωνίας",
    contact_address_label: "Διεύθυνση",
    contact_phone_label: "Αρ. Κινητού",
    contact_email_label: "Email",
    contact_hours_label: "Ωράριο",
    contact_hours_value: "Δευτέρα - Σάββατο | 08:00 - 17:00",
    contact_follow: "Ακολουθήστε μας",
    contact_follow_desc: "Ακολουθήστε μας στα κοινωνικά δίκτυα για νέα και επερχόμενες εκδηλώσεις.",
    contact_name: "Όνομα",
    contact_surname: "Επώνυμο",
    contact_subject: "Θέμα",
    contact_message: "Το μήνυμά σας",
    contact_terms: "Συνεχίζοντας, αποδέχομαι",
    contact_terms_link: "Όρους Χρήσης",
    contact_privacy_link: "Πολιτική Απορρήτου",
    contact_and: "και",
    contact_sending: "Αποστολή...",
    contact_send: "Αποστολή",
    contact_success_title: "Ευχαριστούμε!",
    contact_success_msg: "Το μήνυμά σας στάλθηκε με επιτυχία. Θα επικοινωνήσουμε μαζί σας σύντομα.",
    contact_send_another: "Αποστολή νέου μηνύματος",
    contact_error: "Παρουσιάστηκε σφάλμα. Παρακαλούμε δοκιμάστε ξανά.",
    contact_required: "Παρακαλούμε συμπληρώστε όλα τα υποχρεωτικά πεδία.",
    footer_menu: "Μενού",
    footer_upcoming: "Επερχόμενες Εκδηλώσεις",
    footer_contact: "Επικοινωνία",
    footer_no_events: "Δεν υπάρχουν επερχόμενες εκδηλώσεις.",
    footer_brand: "Η Αλβανική Ακαδημία Aligner για οδοντιάτρους, από οδοντιάτρους.",
    footer_rights: "Όλα τα Δικαιώματα Διατηρούνται",
    footer_powered: "Powered by",
    gallery_title: "Γκαλερί",
    gallery_subtitle: "Στιγμές από τις εκδηλώσεις και τις εκπαιδεύσεις μας.",
    gallery_photos: "φωτογραφία",
    gallery_empty: "Δεν υπάρχουν άλμπουμ στη γκαλερί.",
    blog_title: "Blog",
    blog_subtitle: "Άρθρα και νέα από τον κόσμο της οδοντιατρικής και των aligner.",
    blog_read_more: "Διαβάστε περισσότερα",
    blog_empty: "Δεν υπάρχουν άρθρα στο blog.",
    blog_back: "Επιστροφή στο Blog",
    about_page_title: "Σχετικά με Εμάς",
    about_page_subtitle: "Γνωρίστε την Albanian Aligners Academy - την Αλβανική Ακαδημία για τα Aligner.",
    hero_next_module_prefix: "Ενότητα",
    hero_countdown_days: "Ημέρες",
    hero_countdown_hours: "Ώρες",
    hero_countdown_min: "Λεπτά",
    hero_countdown_sec: "Δευτερόλεπτα",
    hero_masterclass_finished: "Masterclass ολοκληρώθηκε",
    hero_masterclass_6modules: "6 Ενότητες",
    hero_view_more: "Δείτε περισσότερα",
    hero_starts_in: "ΞΕΚΙΝΑΕΙ ΣΕ:",
    home_upcoming_label: "Προσεχείς",
    home_upcoming_title: "Προσεχείς εκδηλώσεις",
    home_upcoming_view_all: "Δείτε όλα",
    home_upcoming_click_to_select: "Κάντε κλικ για επιλογή",
    tier_choose_package: "Επιλέξτε Πακέτο",
    tier_now_badge: "Τώρα",
    tier_expired_badge: "Έληξε",
    tier_click_to_select: "Κάντε κλικ για επιλογή",
    tier_package: "Πακέτο",
    event_topics_label: "Θεματικές",
    event_topics_title: "Πλήρες Πρόγραμμα Ημέρας",
    event_speaker_label: "Ομιλητής",
    event_date_label: "Ημερομηνία",
    event_location_label: "Τοποθεσία",
    event_schedule_label: "Ωράριο",
    event_price_label: "Τιμή",
    register_now: "Εγγραφή",
    register_now_full: "Εγγραφή Τώρα",
    buy_now: "Αγορά Τώρα",
    register_processing: "Επεξεργασία...",
    register_confirm: "Επιβεβαίωση Εγγραφής",
    register_continue_payment: "Συνέχεια στην Πληρωμή",
    popup_event_price: "Τιμή εκδήλωσης",
    popup_saved: "Αποθηκεύτηκε με επιτυχία",
    breadcrumb_home: "Αρχική Σελίδα",
    breadcrumb_events: "Εκδηλώσεις",
    breadcrumb_upcoming: "Προσεχείς Εκδηλώσεις",
    breadcrumb_trainers: "Εκπαιδευτές",
    breadcrumb_privacy: "Πολιτική Απορρήτου",
    trainers_hero_desc: "Διεθνείς και εγχώριοι ειδικοί που φέρνουν εξαιρετική εμπειρία σε κάθε εκπαίδευση.",
    close: "Κλείσιμο",
    cancel: "Ακύρωση",
    save: "Αποθήκευση",
    free: "Δωρεάν",
  },
};
